import React, { useState, useEffect } from 'react'
import './TabOnboarding.scss'
import {Row, Col, Icon, Table, Modal, Spin} from 'antd'
import { getONBFormsPromise } from '../TabDeclarations/promises'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import {ModalPdfViewer} from '../../../InterestConflicts/components'
import { FormModal } from '../../../../layouts/Private/components'
import { ReportService } from '../../../../services/'

const TabOnboarding = ({currentUser, client}) => {
    const { t } = useTranslation(["translations", "forms"])

    const clientName = (client.outsourcer && currentUser.subcliente) ? currentUser.subcliente.name : client.name
    const isInactiveUser = currentUser?.status === 'INACTIVE'
    const [isLoading, setIsLoading] = useState(false)
	const [items, setItems] = useState([])
	const [selectedForm, setSelectedForm] = useState({})
	const [formId, setFormId] = useState (null)
	const [showForm, setShowForm] = useState(false)
    const [lastDoneDate, setLastDoneDate] = useState([])
    const [pendientes, setPendientes] = useState([])
    const [lastPendingDate, setLastPendingDate] = useState(null)

    useEffect(() => {
		handleRefresh();
    }, []);

    const handleRefresh = () => {
        setIsLoading(true)
        getONBFormsPromise(currentUser.id).then((data) => {
            const itemRealizados = data.data.filter((item) => item.statusDecl !== 'PENDIENTE')
            const itemPendientes = data.data.filter((item) => item.statusDecl === 'PENDIENTE')
            const lastDone = itemRealizados.length > 0 ? moment(itemRealizados[0].statusDate).format('DD/MM/YYYY') : null
            const lastFecPendiente = itemPendientes.length > 0 ? moment(itemPendientes[0].statusDate).format('DD/MM/YYYY') : null
            setLastDoneDate(lastDone)
            setPendientes(itemPendientes)
            setLastPendingDate(lastFecPendiente)
			setItems(data.data)
			setIsLoading(false)
		})
    }

    const handlePdfViewer = (record) => {
        setFormId(record.id);
	}

    const onCancelPdfViewer = () => {
        setFormId(null);
    }

    const modalReady = () => {
		setIsLoading(false)
		setShowForm(false)
        handleRefresh();
	}

    const tableColumns = [
        {
            title: t('forms.label.folio', {ns: "forms"}),
            dataIndex: 'folio',
            width: '21%',
            sorter: (a, b) => { return false }
        },
        {
            title: t('messages.aml.request'),
            width: '18%',
            dataIndex: 'sendDate',
            render: (text) => {
                return moment(text).format('DD/MM/YYYY')
            },
            sorter: (a, b) => a.sendDate - b.sendDate,
        },
        {
            title: t('messages.aml.status'),
            width: '18%',
            dataIndex: 'statusDecl',
            render: (text) => {
                return t("messages.aml.formKycStatus."+text)
            },
            sorter: (a, b) => a.statusDecl > b.statusDecl,
        },
        {
            title: t('messages.aml.statusDate'),
            width: '18%',
            dataIndex: 'statusDate',
            render: (statusDate) => statusDate ? moment(statusDate).format('DD/MM/YYYY') : 'N/A',
            sorter: (a, b) => a.statusDate - b.statusDate,
        },
        {
            title: t('portal.cdi.msg.message2', {ns: 'forms'}),
            width: '18%',
            dataIndex: 'lastReminder',
            render: (lastReminder) => lastReminder ? moment(lastReminder).format('DD/MM/YYYY'): t('portal.cdi.msg.message3', {ns: 'forms'}),
            sorter: (a, b) => a.lastReminder - b.lastReminder,
        },
        {
            width: '8%',
            render: ((record) => {
                return(
                    <Row>
                        <Col span={24}>
                            <div className="icon-wrapper-onb-tab">
                                <Row gutter={[0, 0]}>
                                { record.statusDecl !== 'PENDIENTE' ?
                                <Col span={24}>
                                    <Icon type="file-pdf" className="file-pdf"
                                            onClick={ () =>
                                            handlePdfViewer(record) }
                                            style={{fontSize: '20px'}}
                                    />
                                </Col>
                                : !isInactiveUser ?
                                    <>
                                        <Col span={24}>
                                            <Icon 
                                                type="file-add" 
                                                theme="filled"
                                                style={{fontSize: '20px'}}
                                                onClick={ () => openForm(record) }
                                            />
                                        </Col>
                                    </>
                                : null
                                }
                                </Row>
                            </div>
                        </Col>
                    </Row>
                )
            })
        }
    ]

    const openForm = async (form) => {
        if (isInactiveUser) {
            return
        }
		setIsLoading(true)
		setSelectedForm(form);
		setShowForm(true);
	}

    const exportForms = () => {
		ReportService.read('/portal/excelONBDeclarationsByRecordId/' + currentUser.id, null, null, "formularios.xlsx", null, t)
	}

    return ( 
        <div className="stakeholder-tab-content-onboarding">
        <div className="tab-onboarding-stakeholder">
            <Row gutter={[8, 16]} type="flex">
                    <Col span={14}>
                        <div className="section">
                            { isLoading ? <div className="spin-wrapper"><Spin size='large'/></div> :
                                <>
                                    <h3>{t('messages.aml.monitor.dashboard.notification')}</h3>
                                    <div>
                                        <p>{t('portal.onb.welcome.message', { name: currentUser.nombre, ns: "forms"})}</p>
                                        { items.length === 0 ?
                                            <p>{t('portal.onb.welcome.message1', {ns: 'forms'})}</p>
                                        :
                                            pendientes.length === 0 ?
                                            <p>{t('portal.onb.welcome.message2', {lastDoneDate, ns: 'forms'})}</p>
                                        :
                                            <p>{t('portal.onb.welcome.message3', {clientName, lastPendingDate, ns: "forms"})}
                                            {" "}{isInactiveUser
                                                ? <span>formulario de Onboarding</span>
                                                : <a style={{cursor: 'pointer'}} onClick={ () => openForm(pendientes[0]) }>formulario de Onboarding</a>
                                            }.</p>
                                        }
                                    </div>
                                </>
                            }
                        </div>
                    </Col>
                    <Col span={10}>
                        <div className="section">
                        { isLoading ? <div className="spin-wrapper"><Spin size='large'/></div> :
                            <>
                                <h3>{t('portal.cdi.support.title', {ns: "forms"})}</h3>
                                <div>
                                    <p>{t('portal.cdi.welcome.message8', {clientName, ns: "forms"})}</p>
                                    <p>{t('portal.cdi.welcome.message9', {email: 'soporte.aml@gesintel.cl', ns: "forms"})}</p>
                                </div> 
                            </>
                        }
                        </div>
                    </Col>
                </Row>
                <Row gutter={[0, 16]}>
                    <Col span={24}>
                        <div className="section">
                            <Row>
                                <Col span={18}>
                                    <h3>{t('messages.aml.record')}</h3>
                                </Col>
                                <Col span={6} style={{textAlign:'right'}}>
                                    <Icon 
                                        type="reload"
                                        onClick={handleRefresh}
                                        style={{fontSize: '20px', marginRight:'10px'}}
                                    />
                                    <Icon
                                        type="file-excel"
                                        style={{fontSize: '20px'}}
                                        onClick={exportForms}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Table dataSource={ items } columns={ tableColumns } size="small" loading={ isLoading }/>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
                {formId &&
                    <Modal
                        className="modal-pdf-viewer"
                        title="Formulario"
                        centered={true}
                        width={1000}
                        header={null}
                        footer={false}
                        onCancel={onCancelPdfViewer}
                        visible={true}
                        ><ModalPdfViewer
                            pdfId={formId}
                        />
                    </Modal>
                }
                { showForm &&
                    <FormModal client={client} currentUser={currentUser} typeForm={selectedForm.type} form={selectedForm} modalReady={modalReady} />
                }
        </div>
        </div>
    );
}
 
export default TabOnboarding;